module.exports = __webpack_public_path__ + "static/media/maxParties_20_25.44eebf93.png";